module.exports = __webpack_public_path__ + "static/media/social_list.80db6039.svg";